<template>
    <div class="NewChurch container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Add New Church" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <h4>General Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Church Name:</label>
                                <input v-model="TargetRecord.Name" required class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Denomination:</label>
                                <SelectFromEndpoint :required="true" v-model="TargetRecord.Denomination" options-group-name="ChristianDenominations" />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Territory:</label>
                                <select v-model="TargetRecord.SubProgramTerritoryID" required class="form-control">
                                    <option v-for="option in SubProgramTerritoryOptions" :value="option.value">{{option.text}}</option>
                                    <!--<optgroup label="Nevada">
                                        <option value="1c07c68a-9c6c-44fd-b919-6405cfaff445">Nevada</option>
                                    </optgroup>
                                    <optgroup label="California">
                                        <option value="846dae14-36a8-4b42-91e6-32dcf1a9f17e">Coachella</option>
                                        <option value="1708337c-c46d-4a23-a9df-699215381ffe">Inland</option>
                                        <option value="a69dd264-7593-4825-887c-5733257a27b0">Los Angeles</option>
                                        <option value="3b107388-0bcd-4e88-8c34-8bef78e7df05">Orange County</option>
                                        <option value="0e9eb370-8042-497e-97d5-ff50ee3b3b61">San Diego</option>
                                    </optgroup>
                                    <optgroup label="Washington">
                                        <option value="afa9eece-d81b-4bbe-b9f3-6d1e9054afac">Washington East</option>
                                        <option value="f16b918f-8ce3-49c4-bdf7-ed76ebcf026d">Washington West</option>
                                    </optgroup>-->
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Address</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Physical Address:</label>
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine1" class="form-control" placeholder="Address Line 1" required />
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalCity" class="form-control" placeholder="City" required />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.PhysicalStateAbbreviation" required>
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalZipCode" class="form-control" placeholder="Zip" required />
                                    </div>
                                </b-row>
                                <div class="form-group">
                                    <label>County:</label>
                                    <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="TargetRecord.County" required></v-select>
                                </div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Mailing Address: <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress()" class="pointer" /></label>
                                <input type="text" v-model="TargetRecord.MailingAddressLine1" class="form-control" placeholder="Address Line 1 required" />
                                <input type="text" v-model="TargetRecord.MailingAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingCity" class="form-control" placeholder="City" required />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.MailingStateAbbreviation" required>
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingZipCode" class="form-control" placeholder="Zip" required />
                                    </div>
                                </b-row>
                            </div>

                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Relationship</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Olive Crest Relationship Started:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Source of Relationship:</label>
                                <input type="text" class="form-control" v-model="TargetRecord.StatusComments" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import SelectFromEndpoint from '../../../Core/CustomInputElements/SelectFromEndpoint.vue';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    
    export default {
        name: "NewChurch",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                TargetRecord: {}
            };
        },
        methods: {
            //API
            SaveRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/Churches", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                this.$emit("updatetable");
                this.HideModal();
            },
            //UI
            ShowModal() {
                this.TargetRecord = {
                    Denomination: "",
                    PhysicalAddressLine1: "",
                    PhysicalAddressLine2: "",
                    PhysicalCity: "",
                    PhysicalStateAbbreviation: "",
                    PhysicalZipCode: ""
                };
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            CopyPhysicalAddress() {
                this.TargetRecord.MailingAddressLine1 = this.TargetRecord.PhysicalAddressLine1;
                this.TargetRecord.MailingAddressLine2 = this.TargetRecord.PhysicalAddressLine2;
                this.TargetRecord.MailingCity = this.TargetRecord.PhysicalCity;
                this.TargetRecord.MailingStateAbbreviation = this.TargetRecord.PhysicalStateAbbreviation
                this.TargetRecord.MailingZipCode = this.TargetRecord.PhysicalZipCode;
                this.$forceUpdate();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect,
            SelectFromEndpoint
        },
        computed: {
            StateOptions: function () {
                return [
                    {
                        text: "California",
                        value: "CA"
                    },
                    {
                        text: "Nevada",
                        value: "NV"
                    },
                    {
                        text: "Washington",
                        value: "WA"
                    }
                ];
                
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>